var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPaymentIconCvc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 21",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.13 2a8.45 8.45 0 00-1.57 4H0v3h16.74A8.5 8.5 0 0029 14.5V19c0 .94-1.08 2-2 2H2c-.92 0-2-1.06-2-2V4c0-.94 1.08-2 2-2h16.13zM25 14a7 7 0 110-14 7 7 0 010 14zm-2.78-9.9h-.79l-1.93.98v1l1.53-.8V9.9h1.2V4.1zm2.3.8c.57 0 .97.32.97.78 0 .5-.47.85-1.15.85h-.3v.85h.36c.72 0 1.21.36 1.21.88 0 .5-.48.84-1.16.84-.5 0-1-.16-1.52-.47v1c.56.24 1.12.37 1.67.37 1.31 0 2.21-.67 2.21-1.64 0-.68-.42-1.23-1.12-1.45.6-.2.99-.73.99-1.33 0-.94-.83-1.58-2.03-1.58a4 4 0 00-1.57.34v.98c.48-.27.97-.42 1.44-.42zm4.32 2.18c.73 0 1.24.43 1.24.99 0 .59-.51 1-1.24 1-.44 0-.9-.14-1.37-.43v1.03c.49.22.99.33 1.48.33.26 0 .5-.04.73-.1.52-.85.82-1.83.82-2.88l-.02-.42a2.3 2.3 0 00-1.23-.32c-.18 0-.37.01-.57.04v-1.3h1.44a5.62 5.62 0 00-.46-.92h-2.02v3.15c.4-.1.8-.17 1.2-.17z",
    fill: "currentColor"
  })));
}

export default SvgPaymentIconCvc;